var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrosimeBlatWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "faf45518-e1db-499b-8fae-96592059d1ad",
    "data-name": "Layer 52",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 199",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b4d447d9-944c-47db-9ada-abc6f6ea889c,.f0708728-1184-4a22-97a7-bd72785d84ad{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;}.f0708728-1184-4a22-97a7-bd72785d84ad{stroke-width:10px;}.b4d447d9-944c-47db-9ada-abc6f6ea889c{stroke-width:5px;}.b432f29c-8ff8-443e-b1a1-42ef582850bc{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "grosime_blat_white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b1da76af-f6ab-4849-bcb6-72a5926f22c1",
    "data-name": "grosime_panou copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b5891ca5-9d6b-4362-a284-d5a88db1fd06",
    "data-name": "sticla_2 copy 2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "f0708728-1184-4a22-97a7-bd72785d84ad",
    x: 5,
    y: 77,
    width: 190,
    height: 45
  })), /*#__PURE__*/React.createElement("g", {
    id: "b4a7cce3-4cd0-485c-8942-c6053238e274",
    "data-name": "Arrow copy 6"
  }, /*#__PURE__*/React.createElement("line", {
    className: "b4d447d9-944c-47db-9ada-abc6f6ea889c",
    x1: 100,
    y1: 196.5,
    x2: 100,
    y2: 131.71
  }), /*#__PURE__*/React.createElement("path", {
    className: "b432f29c-8ff8-443e-b1a1-42ef582850bc",
    d: "M116.8,156.13a1.75,1.75,0,0,1-2.42-.54L100,133,85.62,155.59a1.75,1.75,0,0,1-2.42.54,1.77,1.77,0,0,1-.54-2.42l15.86-24.9a1.76,1.76,0,0,1,3,0l15.86,24.9a1.79,1.79,0,0,1,.27.94A1.77,1.77,0,0,1,116.8,156.13Z",
    transform: "translate(0 -0.5)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b4d447d9-944c-47db-9ada-abc6f6ea889c",
    x1: 100,
    y1: 2.5,
    x2: 100,
    y2: 67.29
  }), /*#__PURE__*/React.createElement("path", {
    className: "b432f29c-8ff8-443e-b1a1-42ef582850bc",
    d: "M83.2,43.87a1.75,1.75,0,0,1,2.42.54L100,67l14.38-22.58a1.75,1.75,0,0,1,2.42-.54,1.77,1.77,0,0,1,.54,2.42l-15.86,24.9a1.76,1.76,0,0,1-3,0L82.66,46.29a1.79,1.79,0,0,1-.27-.94A1.77,1.77,0,0,1,83.2,43.87Z",
    transform: "translate(0 -0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrosimeBlatWhite);
export default __webpack_public_path__ + "static/media/grosime_blat_white.3ff9bc3392152b2e8f1122d243f57a47.svg";
export { ForwardRef as ReactComponent };